import axios from "axios";
import {
    urlCompaniesEquipment,
    urlEquipmentData, urlMonitorRequestErrors,
    urlNoSyncEquipment,
    urlServerTime
} from "../../../../../constants/endpoints";

export const MONITOR_COLORS = {
    primary: '#0F1F1A',
    secondary: '#1A3A2E',
    tertiary: '#2D6A4F',
    text: {
        primary: '#C8E6C9',
        secondary: '#73C784',
    },
    equipment: {
        machine: '#36D9AE',
        locker: '#2799F5',
        counter: '#FFB300'
    },
    background: {
        machine: '#1B5E20',
        locker: '#0D2A47',
        counter: '#4E2700'
    },
    status: {
        success: '#49AA4E',
        warning: {
            primary: '#653500',
            secondary: '#E8B00D'
        },
        error: {
            primary: '#4A1010',
            secondary: '#E79595'
        }
    }
}

export const formatTime = (totalSeconds) => {
    const s = totalSeconds % 60;
    const m = Math.floor(totalSeconds / 60) % 60;
    const h = Math.floor(totalSeconds / 3600) % 24;
    return [h, m, s].map(n => String(n).padStart(2, '0')).join(':');
};

export const getServerTime = () => {
    return axios.get(urlServerTime);
}

export const getEquipmentData = () => {
    return axios.get(urlEquipmentData);
}

export const getCompaniesEquipment = () => {
    return axios.get(urlCompaniesEquipment);
}

export const getNoSyncEquipment = () => {
    return axios.get(urlNoSyncEquipment);
}

export const getMonitorRequestErrors = () => {
    return axios.get(urlMonitorRequestErrors);
}